<template>
    <section style="margin:18px;">
        <v-flex wrap style="padding: 10px;">
            <v-btn @click="OpenCourseModal">Add Course Topic</v-btn>
        </v-flex>
        <v-data-table :headers="headers" 
                      :items="GetCourseDetailList" 
                      :pagination.sync="pagination" 
                      select-all 
                      item-key="Course_Title" 
                      hide-actions
                      disable-initial-sort
                      :loading='loading' 
                      loading-text="Loading... Please wait"
                      class="elevation-1">
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click="SortColumn(header.value)">
                    <v-icon small>arrow_upward</v-icon> {{ header.text }}
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr>
                    <td class="text-xs-center">{{ props.item.Course_Title }}</td>
                    <td class="text-xs-center">{{ props.item.Course_Details.length }}</td>
                    <td class="text-xs-center">
                        <v-btn color="primary" icon class="btnAction" @click="OpenUpdateCourseModal(props.item)">
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn color="error" icon class="btnAction" @click="DeleteCourseTopic(props.item)">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
        <app-add-course-topic ref='UpdateCourseTopic' :dialog='AddDialog' @close='CloseCourseModal'></app-add-course-topic>
  </section>
</template>
<script>

import appAddCourseTopic from '../views/dialogs/AddCourseTopic'

export default {
    components:{
        appAddCourseTopic 
    },
    data(){
        return {

            AddDialog           : false,
            pagination          : { sortBy: 'Course_Title'},
            headers             : [ { text: 'Course Title',value: 'Course_Title' },{ text: 'No Of Topics' },{ text: 'Actions' } ],
            pages               : 1,
            records             : 0, 
            loading             : false
        }
    },
    computed:{
        GetCourseDetailList(){
            
            return this.$store.getters.GetCourseDetailsList
        }
    },
    methods:{
        
        OpenCourseModal(){

            this.AddDialog = true
        },
        CloseCourseModal(){
            
            this.AddDialog = false

        },
        OpenUpdateCourseModal(Item){

            this.$refs.UpdateCourseTopic.OpenUpdateTopic(Item,"Update")
            this.AddDialog     = true
        },
        DeleteCourseTopic(Course){
            if(confirm("Do you really want to delete?")){
                this.$refs.UpdateCourseTopic.OpenUpdateTopic(Course,"Delete")
                this.AddDialog     = true
            }
        },
        GetNextSetOfData(){
             
             this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                        .then(response =>{

                            this.$store.commit('SetCourseDetailList',response['data']['response'])
                            this.records = response['data']['Records']
                            this.$eventHub.$emit("LOADING",'false')
                            
                        })
                        .catch(err =>{

                            this.$eventHub.$emit("LOADING",'false')
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
        }
    },
    mounted(){

        this.GetNextSetOfData()
    }
}
</script>
<style>
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
</style>